import { type BeforeErrorState, isHTTPError } from '@enterprise/api';

import { customEvents } from '@/constants/custom-events';

export const forbidden = ({ error }: BeforeErrorState): Error | Promise<Error> => {
  if (isHTTPError(error)) {
    const { response } = error;
    const { status } = response;

    if (status === 403) {
      dispatchEvent(new CustomEvent(customEvents.forbidden));
    }
  }

  return error;
};
